import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../services/api.service';
import { HubService } from '../services/hub.service';
import { ProfileService } from '../services/profile.service';
import { DatabaseQuery } from '../types/database-query';

@Component({
  selector: 'queries',
  template: `<div class="queries" *ngIf="CanAdminister(); else notAdmin">
  <admin-sub-menu></admin-sub-menu>
  <mat-form-field id="query_url">
    <mat-select class="form-control"  id="query_url_select" required placeholder="external query source"
              name="query_source" [(ngModel)]="selectedQueryURL" (ngModelChange)="queryURLChanged()">
              <mat-option [value]="self">This Server</mat-option>
              <mat-option *ngFor="let urlKey of externalQueryURLs" [value]="urlKey">{{urlKey}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngFor="let query of queries"
       class="query_row"
      [class.selected]="query === currentQuery"
      [style.background-color]="this.getColorFor(query)"
      (click)="gotoDetail(query)">
    <div class="details">
      <div id="meta">
        <span class="id"><a href="https://monaghan.hubcontrols.com/d/z9sd-yMWz/new-dashboard-copy?orgId=1&var-QID={{query.ID}}" target="{{query.ID}}">{{query.ID}}</a></span>
        <span class="count">{{query.Count}}</span>
        <span class="duration">{{query.Duration | number:'1.4-4'}}</span>
        <span class="average">{{query.Average | number:'1.6-6'}}</span>
      </div>
      <div id="sql">
      {{query.SQL}}
      </div>
    </div>
  </div>
</div>
<ng-template #notAdmin>Not an administrator.</ng-template>
`,
  styles: [`.queries { margin: 0 0 2em 0; padding: 0; min-width: 38em; width: 100%; }`,
    `.query_row { position: relative; padding: 0.2em; margin: 0.1em;
              min-height: 64px; min-width: 38em; width: 100%; }`,
    `.query_row:hover { color: #607D8B; background-color: #DDD; }`,
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.query_row .selected:hover { background-color: #BBD8DC !important; color: white; }`,
    `.query_row .sql { display: inline-block; }`,
    `#meta { display:block; vertical-align: middle; padding: 0.1em 0.8em; line-height: 1.1em; height: available; width: 38em;}`,
    `#meta span.id { display: inline-block; width: 12em; }`,
    `#meta span.count, #meta span.duration, #meta span.average
     { display: inline-block; width: 8em; text-align: right; }`,
    `#sql { display: block; line-height: 1.2em; padding: 0.2em 2em}`,
  ],
  providers: [HubService],
})


export class QueriesComponent implements OnInit {
  CanAdminister: (() => boolean);
  adding = false;
  queries: DatabaseQuery[];
  allqueries: DatabaseQuery[];
  errorMessage: any;
  selectedQueryURL: string = "self";
  externalQueryURLs: string[];

  constructor(
    private ProfileService: ProfileService,
    private HubService: HubService,
    private router: Router,
  ) { 
  }

  ngOnInit(): void {
    if (!ApiService.IsLoggedIn()) { return; }
    this.CanAdminister = ProfileService.CanAdminister;
    if (this.CanAdminister()) {
      this.getQueryURLs();
      this.getqueries();
    }
  }

  queryURLChanged() {
    // console.log("queryURLChanged got called :-)");
    this.getqueries();
  }

  getQueryURLs(): void {
    this.HubService.getQueryURLs().subscribe(
      urls => this.updateQueryURLs(urls),
      error => this.errorMessage = <any>error,
    );
  }

  updateQueryURLs(urls: string[]): void {
    // console.log("Got new URLs! " + JSON.stringify(urls));
    this.externalQueryURLs = urls.sort((a, b) => {
      if (a<b) return -1; 
      if (a>b) return 1; 
      return 0;
    });
  }

  getqueries(): void {
    if (!this.selectedQueryURL) {
      this.selectedQueryURL = "self";
    }
    this.HubService.getQueries(this.selectedQueryURL).subscribe(
      queries => this.updatedqueries(queries),
      error => this.errorMessage = <any>error,
    );
  }

  private updatedqueries(newqueries: DatabaseQuery[]): void {
    this.allqueries = [];
    newqueries.forEach((query: DatabaseQuery) => {
      if (+query.Count > 0 && +query.Duration > 0) {
        query.Average = query.Duration / query.Count;
      }
      this.allqueries.push(query);
    });
    this.queries = this.allqueries.sort((a: DatabaseQuery, b: DatabaseQuery) => {
      // We display the queries with the most total time first
      if (a.Duration<b.Duration) return 1;
      if (a.Duration>b.Duration) return -1;
      return 0;
    });
  }

  gotoDetail(query: DatabaseQuery): void {
    this.router.navigate(['/admin/query/', query.ID]);
  }

  addquery(): void {
    this.adding = true;
  }

  closeDetail(): void {
    this.adding = false;
    this.getqueries();
  }

  getColorFor(query: DatabaseQuery): string {
    if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    if (query.Average < 0.01) { return '#80ff80'; }
    if (query.Average < 0.1) { return '#b0f0c0'; }
    if (query.Average < 1.0) { return '#e0c0a0'; }
    if (query.Average < 10.0) { return '#f08080'; }
    return '#EE4E4E';
  }

}

